export function calendarLinks({ title, description, location, startISO, durationHours = 4 }) {
  const start = new Date(startISO);
  const end = new Date(start.getTime() + durationHours * 3600000);
  const fmt = (d) => d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const s = fmt(start);
  const e = fmt(end);
  const google = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${s}/${e}&details=${encodeURIComponent(description)}&location=${encodeURIComponent(location || "")}`;
  const outlook = `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(title)}&startdt=${start.toISOString()}&enddt=${end.toISOString()}&body=${encodeURIComponent(description)}&location=${encodeURIComponent(location || "")}&path=/calendar/action/compose`;
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Friendsgiving//EN", "BEGIN:VEVENT",
    `UID:${s}@friendsgiving`, `DTSTAMP:${s}`, `DTSTART:${s}`, `DTEND:${e}`,
    `SUMMARY:${title}`, `DESCRIPTION:${description}`, `LOCATION:${location || ""}`,
    "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const icsData = "data:text/calendar;charset=utf-8," + encodeURIComponent(ics);
  return { google, outlook, ics: icsData };
}

export function directionsLink(address) {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address || "")}`;
}
